module.exports = {
  ACCELERATION: 'acceleration',
  ACCELERATION_LAT: 'accelerationLat',
  ADAS_ABS: 'adas.abs',
  ADAS_BLIND_SPOT_MONITORING: 'adas.blindSpotMonitoring',
  ADAS_ESP: 'adas.esp',
  ADAS_FSE: 'adas.fse',
  ADAS_LANE_KEEP_ASSIST_LEFT: 'adas.lane.keepAssist.left',
  ADAS_LANE_KEEP_ASSIST_RIGHT: 'adas.lane.keepAssist.right',
  ADAS_PARK_ASSIST_FRONT_ALARM: 'adas.parkAssist.front.alarm',
  ADAS_PARK_ASSIST_FRONT_MUTED: 'adas.parkAssist.front.muted',
  ADAS_PARK_ASSIST_REAR_ALARM: 'adas.parkAssist.rear.alarm',
  ADAS_PARK_ASSIST_REAR_MUTED: 'adas.parkAssist.rear.muted',
  ADAS_SLI: 'adas.sli',
  ALERTS: 'alerts',
  ELECTRICITY_CAPACITY: 'electricity.capacity',
  ELECTRICITY_CHARGING_MODE: 'electricity.charging.mode',
  ELECTRICITY_CHARGING_PLANNED: 'electricity.charging.planned',
  ELECTRICITY_CHARGING_PLUGGED: 'electricity.charging.plugged',
  ELECTRICITY_CHARGING_RATE: 'electricity.charging.rate',
  ELECTRICITY_CHARGING_REMAINING_TIME: 'electricity.charging.remainingTime',
  ELECTRICITY_CHARGING_STATUS: 'electricity.charging.status',
  ELECTRICITY_ENGINE_SPEED: 'electricity.engine.speed',
  ELECTRICITY_ENGINE_STATUS: 'electricity.engine.status',
  ELECTRICITY_RESIDUAL_AUTONOMY: 'electricity.residualAutonomy',
  ELECTRICITY_LEVEL_PERCENTAGE: 'electricity.level.percentage',
  CRASH_AUTO_ECALL: 'crash.autoEcall',
  CRASH_FRONT_NEED_REPAIR: 'crash.front.needRepair',
  CRASH_FRONT_SEVERITY: 'crash.front.severity',
  CRASH_LATERAL_NEED_REPAIR: 'crash.lateral.needRepair',
  CRASH_LATERAL_SEVERITY: 'crash.lateral.severity',
  CRASH_PEDESTRIAN: 'crash.pedestrian',
  CRASH_REAR_NEED_REPAIR: 'crash.rear.needRepair',
  CRASH_REAR_SEVERITY: 'crash.rear.severity',
  CRASH_TIPPED_OVER: 'crash.tippedOver',
  DATETIME: 'datetime',
  DATETIME_SENDING: 'datetimeSending',
  DOORS_LOCKED: 'doors.locked',
  ECODRIVING_EVENT: 'ecodriving.event',
  ECODRIVING_FROM_DATE: 'ecodriving.from.date',
  ECODRIVING_FROM_GEOLOCATION_POSITION: 'ecodriving.from.geolocation.position',
  ECODRIVING_FUEL_CONSUMPTION: 'ecodriving.fuel.consumption',
  ECODRIVING_FUEL_LEVEL_PERCENTAGE: 'ecodriving.fuel.level.percentage',
  ECODRIVING_LEVEL: 'ecodriving.level',
  ECODRIVING_PRIVACY: 'ecodriving.privacy',
  ECODRIVING_PRIVACY_STATE: 'ecodriving.privacyState',
  ECODRIVING_REQUESTED_PRIVACY: 'ecodriving.requestedPrivacy',
  ECODRIVING_REQUESTED_PRIVACY_STATE: 'ecodriving.requestedPrivacyState',
  ECODRIVING_ODOMETER: 'ecodriving.odometer',
  ECODRIVING_THRESHOLDS: 'ecodriving.thresholds',
  ECODRIVING_THRESHOLDS_1: 'ecodriving.thresholds.1',
  ECODRIVING_THRESHOLDS_2: 'ecodriving.thresholds.2',
  ECODRIVING_TO_DATE: 'ecodriving.to.date',
  ECODRIVING_TO_GEOLOCATION_POSITION: 'ecodriving.to.geolocation.position',
  ENGINE_BATTERY_CAPACITY_PERCENTAGE: 'engine.battery.capacity.percentage',
  ENGINE_BATTERY_CHARGING: 'engine.battery.charging',
  ENGINE_BATTERY_RESISTANCE_PERCENTAGE: 'engine.battery.resistance.percentage',
  ENGINE_BATTERY_VOLTAGE: 'engine.battery.voltage',
  ENGINE_COOLANT_TEMPERATURE: 'engine.coolant.temperature',
  ENGINE_CONTACT: 'engine.contact',
  ENGINE_IGNITION: 'engine.ignition',
  ENGINE_RUN_TIME: 'engine.runTime',
  ENGINE_OIL_LIFE_LEFT_PERCENTAGE: 'engine.oil.lifeLeft.percentage',
  ENGINE_OIL_PRESSURE: 'engine.oil.pressure',
  ENGINE_OIL_TEMPERATURE: 'engine.oil.temperature',
  ENGINE_SPEED: 'engine.speed',
  ENGINE_STATUS: 'engine.status',
  EXTERNAL_TEMPERATURE: 'externalTemperature',
  FUEL_ENGINE_SPEED: 'fuel.engine.speed',
  FUEL_ENGINE_STATUS: 'fuel.engine.status',
  FUEL_AVERAGE_CONSUMPTION: 'fuel.averageConsumption',
  FUEL_INSTANT_CONSUMPTION: 'fuel.instantConsumption',
  FUEL_LEVEL: 'fuel.level',
  FUEL_LEVEL_PERCENTAGE: 'fuel.level.percentage',
  FUEL_RESIDUAL_AUTONOMY: 'fuel.residualAutonomy',
  FUEL_TOTAL_CONSUMPTION: 'fuel.totalConsumption',
  GEOLOCATION_ALTITUDE: 'geolocation.altitude',
  GEOLOCATION_GPS_SIGNAL: 'geolocation.gpsSignal',
  GEOLOCATION_GPS_ACCURACY: 'geolocation.gpsAccuracy',
  GEOLOCATION_POSITION: 'geolocation.position',
  GEOLOCATION_SOURCE: 'geolocation.source',
  HEADING: 'heading',
  LIGHTS_FOG_FRONT: 'lights.fog.front',
  LIGHTS_FOG_REAR: 'lights.fog.rear',
  LIGHTS_TURN: 'lights.turn',
  LIGHTS_WARNINGS: 'lights.warnings',
  MAINTENANCE_DATE: 'maintenance.date',
  MAINTENANCE_ODOMETER: 'maintenance.odometer',
  ODOMETER: 'odometer',
  MOVING: 'moving',
  PACE: 'pace',
  REMOTE_ACTIONS_IMMOBILIZE_STATUS: 'remoteActions.immobilize.status',
  REMOTE_ACTIONS_LOCK_STATUS: 'remoteActions.lock.status',
  REMOTE_ACTIONS_UNIMMOBILIZE_STATUS: 'remoteActions.unimmobilize.status',
  REMOTE_ACTIONS_UNLOCK_STATUS: 'remoteActions.unlock.status',
  REMOTE_ACTIONS_VISUAL_LOCALISATION_STATUS: 'remoteActions.visualLocalisation.status',
  REMOTE_ACTIONS_SOUND_LOCALISATION_STATUS: 'remoteActions.soundLocalisation.status',
  SEATBELT_DRIVER: 'seatbelt.driver',
  SEATBELT_PASSENGER_FRONT: 'seatbelt.passenger.front',
  SEATBELT_PASSENGER_REAR_LEFT: 'seatbelt.passenger.rear.left',
  SEATBELT_PASSENGER_REAR_RIGHT: 'seatbelt.passenger.rear.right',
  SEATBELT_PASSENGER_REAR_CENTRAL: 'seatbelt.passenger.rear.central',
  SETUP_ADAS_BLIND_SPOT_MONITORING: 'setup.adas.blindSpotMonitoring',
  SETUP_ADAS_LANE_KEEP_ASSIST: 'setup.adas.laneKeepAssist',
  SETUP_PRIVACY: 'setup.privacy',
  SETUP_PRIVACY_STATE: 'setup.privacyState',
  SETUP_REQUESTED_PRIVACY: 'setup.requestedPrivacy',
  SETUP_REQUESTED_PRIVACY_STATE: 'setup.requestedPrivacyState',
  SPEED: 'speed',
  STATUS: 'status',
  TIRE_PRESSURE_FRONT_LEFT: 'tirePressure.front.left',
  TIRE_PRESSURE_FRONT_RIGHT: 'tirePressure.front.right',
  TIRE_PRESSURE_REAR_LEFT: 'tirePressure.rear.left',
  TIRE_PRESSURE_REAR_RIGHT: 'tirePressure.rear.right',
  TRANSMISSION_GEAR_STATE: 'transmissionGear.state',
  INTERNAL_MESSAGE_ID: '_internal.messageId',
  INTERNAL_TRIP_ID: '_internal.tripId',
  INTERNAL_TRIP_EVENT: '_internal.tripEvent',
  INTERNAL_TRIP_FUEL_CONSUMPTION: '_internal.tripFuelConsumption',
  INTERNAL_FUEL_LEVEL: '_internal.fuelLevel',
};
